import { createStore, applyMiddleware, compose } from "redux";
import thunk from 'redux-thunk'
import api from "./middleware/api";
import mainReducer from './reducers'

function configureStore() {
    return createStore(
        mainReducer,
        compose(applyMiddleware(thunk, api))
    )
};

export default configureStore;